const badEvents = {
  COLLAPSE: 'bad:collapse',
  CLAS_SLOT_RENDER_ENDED: 'bad:clas:slotRenderEnded',
  SLOT_RENDER_ENDED: 'bad:slotRenderEnded',
}

export default badEvents;